'use client';

import type { PropsWithChildren } from 'react';
import { useSlideAnimationContext } from './Provider/SlideAnimationProvider';

export const SlideAnimationWrapper = ({
  children,
  className = 'questionnaire',
}: PropsWithChildren<{ className?: string }>) => {
  const { slideClass } = useSlideAnimationContext();

  return (
    <div className={`${className}`}>
      <div className={`${className}__inner`}>
        <div className={`${className}__inner__centered`}>
          <div className={`${className}__slide ${slideClass}`}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
